import React from "react";
import { NavLink, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();
  const { lang } = useParams();
  const base = `/${lang || "ar"}`;
  return (
    <section className="fp-notfound">
      <span className="fp-eyebrow">404</span>
      <h1>{t("header.brand")}</h1>
      <p>{t("footer.about_body")}</p>
      <NavLink to={base} className="fp-btn fp-btn--primary">{t("header.nav.home")}</NavLink>
    </section>
  );
}
